import(/* webpackMode: "eager" */ "/opt/synthhotel/app/page.tsx");
